var sortOptions = {
  LAST_UPDATED: 'lastUpdated'
};
export default sortOptions;
//# sourceMappingURL=sort-options.js.map